export default "__VITE_ASSET__DwR0SW2I__"